<template>

  <t-page>

    <t-page-general :current-page="currentPage" :user-auth="userAuth">

      <t-report-generate
          v-if="relationAccessSubValidation('sub-polimix-stock-report-in-out')"
          enabled-total-by-period
          total-by-period-help="Insere um totalizador por produto"
          v-model="reportStockDetail"
          enable-generate-excel
          sub-validation-tag="sub-polimix-stock-report-in-out"
          title="Extrato de Estoque">

        <t-input-search v-model="reportStockDetail.dateRange" date enable-range
                        label="Data Produzido"/>

        <t-input-search v-model="reportStockDetail.stockPlaceProductInsideId" :options="stockPlaceProductInsideOptions"
                        label="Local de Armazenamento" select/>

        <t-input-search v-model="reportStockDetail.groupProductId"
                        :options="groupProductOptions"
                        label="Grupo"
                        select/>

        <t-input-search label="Forma Física" placeholder="Todas" v-model="reportStockDetail.unitId"
                        :options="unitOptions" select/>

      </t-report-generate>

      <t-report-generate
          v-if="relationAccessSubValidation('sub-polimix-stock-report-time-expedition')"
          v-model="reportExpeditionTime"
          enable-generate-excel
          sub-validation-tag="sub-polimix-stock-report-time-expedition"
          title="Tempo Produção à Expedição">


        <t-input-search v-model="reportExpeditionTime.productionIssueDate" date enable-range
                        label="Data Produzido"/>


        <t-input-search v-model="reportExpeditionTime.dateRange" date date-monthly enable-range
                        label="Data Expedido"/>

        <t-input-person customer
                        v-model="reportExpeditionTime.customerId"/>

        <t-input-search v-model="reportExpeditionTime.groupProductId"
                        :options="groupProductOptions"
                        label="Grupo"
                        select/>

        <b-row>

          <t-input-search label="Modelo" v-model="reportExpeditionTime.modelId"
                          :options="modelOptions" cols="6" select/>

          <t-input-search label="Forma Física" placeholder="Todas" v-model="reportExpeditionTime.unitId"
                          :options="unitOptions" cols="6" select/>

        </b-row>


      </t-report-generate>

      <t-report-generate
          v-if="relationAccessSubValidation('sub-polimix-stock-report-expedition')"
          v-model="reportExpeditionDetail"
          enable-generate-excel
          sub-validation-tag="sub-polimix-stock-report-expedition"
          title="Extrato de Expedição">

        <t-input-search v-model="reportExpeditionDetail.dateRange" date date-monthly enable-range
                        label="Data Emissão"/>


        <t-input-person customer
                        v-model="reportExpeditionDetail.customerId"/>


        <t-input-search v-model="reportExpeditionDetail.expeditionStatusId" :options="typeExpeditionStatusOptions"
                        select
                        label="Status Expedição"/>

      </t-report-generate>

    </t-page-general>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import unitService from "@/services/modules/product/Unit.service";
import groupProductService from "@/services/modules/product/GroupProduct.service";
import stockMoldLocationService from "@/services/modules/stock/StockPlaceProductInside.service";
import modelService from "@/services/modules/product/Model.service";

export default {

  mixins: [pageDefaultMixin],
  name: 'PolimixPStockReport',
  data() {
    return {
      path: "stock/report", //Path padrão para validação, porém página foi configurada para validação direta na mesma página (validationOtherPageId)
      reportStockDetail: {
        dateRange: "",
        groupProductId: 0,
        unitId: 0,
        stockPlaceProductInsideId: 1,//Padrão estoque Liberados
      },
      reportExpeditionDetail: {
        dateRange: "",
        customerId: 0,
        expeditionStatusId: 2,//Padrão já finalizados
      },
      reportExpeditionTime: {
        dateRange: "",
        productionIssueDate: "",
        customerId: 0,
        groupProductId: 0,
        unitId: 0,
        modelId: 0,
      },
      groupProductOptions: [],
      unitOptions: [],
      modelOptions: [],
      stockPlaceProductInsideOptions: [],
      typeExpeditionStatusOptions: [],
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      await unitService.selectList().then((response) => {
        this.unitOptions = response
      }).catch(error => this.responseError(error))


      await stockMoldLocationService.selectList().then((list) => {
        this.stockPlaceProductInsideOptions = list
      }).catch(error => this.responseError(error))

      await groupProductService.selectList().then((list) => {
        this.groupProductOptions = list
      }).catch(error => this.responseError(error))

      await modelService.selectList().then((list) => {
        this.modelOptions = list
      }).catch(error => this.responseError(error))

    },

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedDefault()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
